export const identify = (userId) => {
  if(!userId || !window.cioanalytics) return;

  window.cioanalytics.identify(userId);
  window.cioanalytics.page()
};

export const track = (name, properties) => {
  if(!window.cioanalytics) return;

  window.cioanalytics.track(name, properties);
};

export const listingAnalyticsViewed = (properties) => {
  track('listing_analytics_viewed', {
    product: 'mymarket',
    timestamp: Math.floor(Date.now() / 1000),
    ...properties,
  })
};

export const testEvent = () => track('test_event');
